import Template from 'pages/components/Template'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ExportsWrapper } from './styles'
import Header from 'components/Header'
import { Tabs } from 'antd'
import InOut from './components/InOut'
import Cancellations from 'pages/Exports/components/Cancellations'
import RoomAppointments from 'pages/Exports/components/RoomAppointments'
import ParcelsUndelivered from 'pages/Exports/components/ParcelsUndelivered'
import PostalListExport from 'pages/Exports/components/PostalList'
import Quiets from 'pages/Exports/components/Quiets'
import { Drawer } from 'antd'
import StateIcon from 'components/StateIcon'

const Exports = () => {
  const { t } = useTranslation()
  const [showExportConfirmation, setShowExportConfirmation] = useState(false)

  return (
    <Template
      activeMenu="/exports"
    >
      {(currentUser, currentCenters) =>
        <ExportsWrapper>
          <Header
            title={t('exports.title')}
            currentUser={currentUser}
            currentCenters={currentCenters}
          />
          <Tabs defaultActiveKey="postal-list-export">
            <Tabs.TabPane
              key="postal-list-export"
              tab={t('exports.postal-list-export.title')}
            >
              <PostalListExport
                onShowExportConfirmation={() => setShowExportConfirmation(true)}
              />
            </Tabs.TabPane>
            <Tabs.TabPane
              key="in-out"
              tab={t('exports.in-out.title')}
            >
              <InOut
                onShowExportConfirmation={() => setShowExportConfirmation(true)}
              />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="cancellations"
              tab={t('exports.cancellations.title')}
            >
              <Cancellations
                onShowExportConfirmation={() => setShowExportConfirmation(true)}
              />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="quiets"
              tab={t('exports.quiets.title')}
            >
              <Quiets
                onShowExportConfirmation={() => setShowExportConfirmation(true)}
              />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="roomAppointments"
              tab={t('exports.room-appointments.title')}
            >
              <RoomAppointments
                onShowExportConfirmation={() => setShowExportConfirmation(true)}
              />
            </Tabs.TabPane>
            <Tabs.TabPane
              key="parcelsUndelivered"
              tab={t('exports.parcels-undelivered.title')}
            >
              <ParcelsUndelivered
                onShowExportConfirmation={() => setShowExportConfirmation(true)}
              />
            </Tabs.TabPane>
          </Tabs>

          <Drawer
            visible={showExportConfirmation}
            width={320}
            onClose={() => setShowExportConfirmation(false)}
          >
            <StateIcon type="success" /> <br/>

            {t('exports.confirmation')}
          </Drawer>
        </ExportsWrapper>
      }
    </Template>
  )
}

export default Exports
